import { InfoCircleBigIcon } from '@app/components/icons/info-circle-big';
import { Tooltip } from '@app/components/tooltip';
import { useAnalytics } from '@app/features/analytics/hooks/use-analytics';
import { useTranslation } from '@hopin-team/provider-translation';
import React from 'react';

type SeatTileProps = {
  count: number;
  labelKey: string;
  tooltipKey: string;
  percentage?: number;
  tooltipLocation?: string;
};

export const SeatTile = ({
  count,
  labelKey,
  tooltipKey,
  percentage,
  tooltipLocation,
}: SeatTileProps) => {
  const { t } = useTranslation();
  const { track } = useAnalytics();
  const label = t(labelKey);
  const tooltipContent = t(tooltipKey);

  const handleTooltipHover = () => {
    if (!tooltipLocation) {
      return;
    }

    track('ola_admin_tab_tooltip_hover', {
      location: tooltipLocation,
    });
  };

  return (
    <div
      className="flex flex-col rounded-2xl border border-neutral-b4 px-5.25 pt-6 pb-5.75"
      data-testid={`seat-tile-${labelKey}`}
    >
      <div className="flex items-center gap-2 justify-center">
        <span className="text-kpi-count text-gray-900">{count}</span>
        {percentage && (
          <>
            <div className="h-3 w-px bg-neutral-b4" aria-hidden />
            <span className="text-title text-neutral-b2">{percentage}%</span>
          </>
        )}
      </div>
      <div className="flex items-start gap-1 pt-1">
        <span className="whitespace-nowrap text-title text-neutral-b2">
          {label}
        </span>
        <Tooltip tooltip={tooltipContent} placement="bottom-center">
          <span
            className="inline-flex cursor-pointer"
            aria-label={tooltipContent}
            data-testid="seat-tile-tooltip-trigger"
            onMouseEnter={handleTooltipHover}
          >
            <InfoCircleBigIcon width={24} height={24} aria-hidden />
          </span>
        </Tooltip>
      </div>
    </div>
  );
};
